import Alpine from "alpinejs";
import morph from "@alpinejs/morph";

import "../../../../JvMTECH.Components/Resources/Private/Main.js";

Alpine.plugin(morph);
Alpine.start();
if (!window.Alpine) {
    window.Alpine = Alpine;
}

if (process.env.NODE_ENV === "development") {
    console.log("JvMTECH.Base Main.js loaded");
    /**
     * GSAP IS NOT LOADED! Uncomment in
     * ../../../Configuration/Settings.IncludeAssets.yaml
     */
}
